import Head from 'next/head'

import { LS_APP_DOMAIN } from 'config/constants'

const MetaTags = ({ resolvedUrl, article }) => {
  const pathName = resolvedUrl.split('?')[0]

  const title = '精選居家生活知識與經典文章，讓生活變得更美好 - 信義居家'

  return (
    <Head>
      <title>{title}</title>

      <link
        key="canonical"
        rel="canonical"
        href={`${LS_APP_DOMAIN + pathName}`}
      />

      {/* For Google */}
      <meta key="title" name="title" content={title} />
      <meta
        key="description"
        name="description"
        content="信義居家蒐集各種居家生活知識與經典文章：室內設計經典案例、實際裝潢案例分享、裝潢知識蒐集、居家風水佈置介紹、家事清潔小技巧等居家生活文章都再信義居家"
      />

      {/* For Facebook */}
      <meta key="og:title" property="og:title" content={title} />
      <meta
        key="og:description"
        property="og:description"
        content="信義居家蒐集各種居家生活知識與經典文章：室內設計經典案例、實際裝潢案例分享、裝潢知識蒐集、居家風水佈置介紹、家事清潔小技巧等居家生活文章都再信義居家"
      />
      <meta
        key="og:image"
        property="og:image"
        content={article?.image?.url || ''}
      />
    </Head>
  )
}

export default MetaTags
